import {
  CopyOutlined,
    FileExcelOutlined,
    FilePdfOutlined,
    PlusOutlined,
    SearchOutlined,
  } from '@ant-design/icons';
  import {
    Breadcrumb,
    Button,
    Checkbox,
    Col,
    Drawer,
    Dropdown,
    Form,
    Input,
    Menu,
    Pagination,
    Popconfirm,
    Row,
    Space,
    Table,
    Tooltip,
    message,
  } from 'antd';
  import dayjs from 'dayjs';
  import jsPDF from 'jspdf';
  import 'jspdf-autotable';
  import { useEffect, useMemo, useRef, useState } from 'react';
  import { CSVLink } from 'react-csv';
  import { useDispatch, useSelector } from 'react-redux';
  import { Link, useNavigate } from 'react-router-dom';
  import { ReactComponent as Archiveicon } from '../../Images/Archiveicon.svg';
  import { ReactComponent as Back } from '../../Images/Back.svg';
  import { ReactComponent as ColumnList } from '../../Images/ColumnList.svg';
  import { ReactComponent as EditIcon } from '../../Images/EditIcon.svg';
  import { ReactComponent as FilterIcon } from '../../Images/FilterIcon.svg';
  import { ReactComponent as Archive } from '../../Images/archive.svg';
  import {
    createVehicle,
    deleteVehicle,
    fetchVehicleList,
    resetVehicleList,
    updateVehicle,
  } from './../../slices/vehicle';
  import moment from 'moment';
  import { debounce } from 'lodash';
  import { fetchAndSetIpAddress } from '../../slices/ipSlice';
  import { createActivityLog } from '../../slices/activity-log';
  import { createNumberValidationRule } from '../../utils/CreateNumberValidationRule';
  import logo from '../../Images/alux-logo.png';
  
  function VehicleList() {
      let navigate = useNavigate();
    const [form] = Form.useForm();
    const latestRequestIdRef = useRef(0);
    const abortControllerRef = useRef();

    const [page, setPage] = useState(1);

    const [pagesize, setPageSize] = useState(20);
    const [orderBy, setOrderBy] = useState('');
  
    const [isDrawerVisible, setIsDrawerVisible] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [currentRecord, setCurrentRecord] = useState(null);
    const [dropdownVisible, setDropdownVisible] = useState(false); // Keep the dropdown visible
    const [checkedList, setCheckedList] = useState(['SrNo', 'party_name','vehicle_no','tare_wt', 'action']);
    const [search, setSearch] = useState(
      localStorage.getItem('logistic_text_search_vehicle') || '',
    );
 
  
    const dispatch = useDispatch();
    const { user: currentUser } = useSelector(state => state.auth);
    const {
      data = [],
      totalRecord,

      loading,
    } = useSelector(state => state.vehicle || {});
    const ipAddress = useSelector(state => state.ip.ipAddress);
    useEffect(() => {
      dispatch(fetchAndSetIpAddress());
    });
    useEffect(() => {

    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    abortControllerRef.current = new window.AbortController();
    const signal = abortControllerRef.current.signal;
    latestRequestIdRef.current += 1;
    const requestId = latestRequestIdRef.current;
      dispatch(resetVehicleList());
      dispatch(
        fetchVehicleList({
          page,
          pagesize,
          ...(search && { search: search }),
          ...(orderBy && { ordering: orderBy }), signal, requestId,
        }),
      ).then(() => {
        if (requestId === latestRequestIdRef.current) {
          // Only update if this is the latest request
        }
      });
    }, [dispatch,page, pagesize, search, orderBy]);
    const onEdit = record => {
      setIsEditing(true);
      setCurrentRecord(record);
      form.setFieldsValue({
        party_name: record.party_name,
        vehicle_no: record.vehicle_no,
        tare_wt: record.tare_wt,
      });
      setIsDrawerVisible(true);
    };
  
    const onFinish = async values => {
      try {
        if (currentRecord) {
          await dispatch(
            updateVehicle({ id: currentRecord.id, values }),
          ).unwrap();
          message.success('Vehicle updated successfully!');
        } else {
          values.deleted = 0;
          await dispatch(createVehicle(values)).unwrap();
          message.success('Vehicle added successfully!');
          dispatch(
            fetchVehicleList({
              page,
              pagesize,
              ...(search && { search: search }),
            }),
          );
        }
        setPage(1);
        dispatch(resetVehicleList());
  
        form.resetFields();
        setIsDrawerVisible(false);
        setCurrentRecord(null);
      } catch (error) {
        handleError(error);
      }
    };
    const showDrawer = () => {
      setIsDrawerVisible(true);
    };
  
    const closeDrawer = () => {
      setIsDrawerVisible(false);
      setIsEditing(false);
      form.resetFields();
      setFormErrorMessage(' ');
      setCurrentRecord(null);
    };
    const resetFilter = () => {
      setSearch('');
  

      setOrderBy(null); // if applicable
      localStorage.removeItem('logistic_text_search_vehicle');
      dispatch(fetchVehicleList({ page: 1, pagesize }));
    };
  
    const handlePageChange = newPage => {
      setPage(newPage);
    };
  
    const handlePageSizeChange = (current, size) => {
      setPage(1); // Reset to first page if needed
      setPageSize(size); // You must have a setter or state update
    };
  
    const GetSortingEnumValue = (sortField, sortOrder) => {
      let sortingEnumKey = 'id';
  
      if (sortField === 'party_name' && sortOrder === 'ascend') {
        sortingEnumKey = 'party_name';
      }
      if (sortField === 'party_name' && sortOrder === 'descend') {
        sortingEnumKey = '-party_name';
      }
      if (sortField === 'vehicle_no' && sortOrder === 'ascend') {
        sortingEnumKey = 'vehicle_no';
      }
      if (sortField === 'vehicle_no' && sortOrder === 'descend') {
        sortingEnumKey = '-vehicle_no';
      }
      if (sortField === 'tare_wt' && sortOrder === 'ascend') {
        sortingEnumKey = 'tare_wt';
      }
      if (sortField === 'tare_wt' && sortOrder === 'descend') {
        sortingEnumKey = '-tare_wt';
      }
      if (sortField === 'created_at' && sortOrder === 'ascend') {
        sortingEnumKey = 'created_at';
      }
      if (sortField === 'created_at' && sortOrder === 'descend') {
        sortingEnumKey = '-created_at';
      }
      if (sortField === 'updated_at' && sortOrder === 'ascend') {
        sortingEnumKey = 'updated_at';
      }
      if (sortField === 'updated_at' && sortOrder === 'descend') {
        sortingEnumKey = '-updated_at';
      }
      if (sortField === 'updated_by_name' && sortOrder === 'ascend') {
        sortingEnumKey = 'updated_by_name';
      }
      if (sortField === 'updated_by_name' && sortOrder === 'descend') {
        sortingEnumKey = '-updated_by_name';
      }
      if (sortField === 'created_by_name' && sortOrder === 'ascend') {
        sortingEnumKey = 'created_by_name';
      }
      if (sortField === 'created_by_name' && sortOrder === 'descend') {
        sortingEnumKey = '-created_by_name';
      }
      return sortingEnumKey;
    };
  
    const handleTableChange = async (pagination, filters, sorter) => {
      if (sorter?.columnKey && sorter.order) {
        const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
        setOrderBy(orderBy);
      }
      if (pagination?.pageSize) setPageSize(pagination.pageSize);
      if (pagination?.current) setPage(pagination.current);
    };
  
    const debouncedAPICall = useMemo(
      () =>
        debounce(query => {
          if (abortControllerRef.current) {
            abortControllerRef.current.abort();
          }
          abortControllerRef.current = new window.AbortController();
          const signal = abortControllerRef.current.signal;
          latestRequestIdRef.current += 1;
          const requestId = latestRequestIdRef.current;
          if (query.length >= 3) {
            dispatch(fetchVehicleList({
              page: 1,
              pagesize,
              search: query,
              signal,
              requestId,
            }));
            localStorage.setItem('logistic_text_search_vehicle', query);
          } else if (query.length === 0) {
            dispatch(fetchVehicleList({
              page: 1,
              pagesize,
              signal,
              requestId,
            }));
            localStorage.removeItem('logistic_text_search_vehicle');
          }
        }, 100),
      [dispatch, pagesize],
    );
  
    const handleSearch = e => {
      const value = e.target.value;
      debouncedAPICall(value);
  
      setSearch(value);
      localStorage.setItem('logistic_text_search_vehicle', value);
    };
  
    useEffect(() => {
      return () => {
        debouncedAPICall.cancel();
        if (abortControllerRef.current) {
          abortControllerRef.current.abort();
        }
      };
    }, [debouncedAPICall]);
  
    const dataSource = data?.map((item, index) => ({
      ...item,
      key: item.id || index,
      SrNo: (page - 1) * pagesize + index + 1, // Calculate Sr. No. based on page and limit
    }));
  
    const [formErrorMessage, setFormErrorMessage] = useState('');
  
    const handleError = error => {
      if (typeof error === 'object' && error !== null) {
        const messages = [];
        for (const key in error) {
          if (Array.isArray(error[key])) {
            // Replace underscores with spaces in the key
            messages.push(`${key.replace(/_/g, ' ')}: ${error[key].join(', ')}`);
          }
        }
        if (messages.length > 0) {
          setFormErrorMessage(messages.join('; '));
        } else {
          setFormErrorMessage('An unknown error occurred.');
        }
      } else if (typeof error === 'string') {
        setFormErrorMessage(error);
      } else if (error instanceof Error) {
        setFormErrorMessage(error.message);
      } else {
        setFormErrorMessage('An unknown error occurred.');
      }
    };
  
    const handleDelete = id => {
      if (!id) {
        message.error('Missing ID for deletion!');
        return;
      }
  
      dispatch(deleteVehicle(id))
        .unwrap()
        .then(() => {
          message.success('Vehicle Archive Successfully!');
        })
        .catch(error => {
          if (typeof error === 'object' && error !== null) {
            const messages = [];
            for (const key in error) {
              if (Array.isArray(error[key])) {
                messages.push(`${key}: ${error[key].join(', ')}`);
              }
            }
  
            if (messages.length > 0) {
              message.error(messages.join('; '));
            } else {
              message.error('An unknown error occurred.');
            }
          } else if (typeof error === 'string') {
            message.error(error); // Handle string error
          } else if (error instanceof Error) {
            message.error(error.message); // Handle Error object
          } else {
            message.error('An unknown error occurred.');
          }
        });
    };
    const columns = [
      {
        title: 'Sr. No.',
        dataIndex: 'SrNo',
        key: 'SrNo',
        width: 100,
      },
      {
        title: 'Party Name',
        dataIndex: 'party_name',
        key: 'party_name',
        sorter: true,
        width: 300,
        render: record => {
         
          return (
            <span>
              {record ? `${record}` : 'N/A'}
            </span>
          );
        },
      },
      {
        title: 'Vehicle No.',
        dataIndex: 'vehicle_no',
        key: 'vehicle_no',
        sorter: true,
        width: 300,
        render: record => {
          return (
            <span>
              {record ? `${record}` : 'N/A'}
            </span>
          );
        },
      },
      {
        title: 'Tare WT',
        dataIndex: 'tare_wt',
        key: 'tare_wt',
        sorter: true,
        width: 300,
        render: record => {
          return (
            <span>
              {record ? `${record}` : 'N/A'}
            </span>
          );
        },
        
      },
      {
        title: 'Created At',
        dataIndex: 'created_at',
        key: 'created_at',
        width: 100,
        sorter: true,
        render: record => {
          return (
            <span>
              {record ? dayjs(record).format('DD-MM-YYYY HH:mm') : 'N/A'}
            </span>
          );
        },
      },
      {
        title: 'Created By',
        dataIndex: 'created_by_name',
        key: 'created_by_name',
        width: 100,
        sorter: true,
        render: record => {
          {console.log("record created_by_name",record)}
          return (
          
            <span>
              {record ? `${record}` : 'N/A'}
            </span>
          );
        },
      },
      {
        title: 'Updated At',
        dataIndex: 'updated_at',
        key: 'updated_at',
        width: 100,
        sorter: true,
        render: record => {
          return (
            <span>
              {record && record.trim()
                ? dayjs(record).format('DD-MM-YYYY HH:mm')
                : 'N/A'}
            </span>
          );
        },
      },
      {
        title: 'Updated By',
        dataIndex: 'updated_by_name',
        key: 'updated_by_name',
        width: 100,
        sorter: true,
        render: record => {
          {console.log("record updated_by_name",record)}
          return (
            <span>
              {record 
                ? `${record}`
                : 'N/A'}
            </span>
          );
        },
      },
      {
        title: 'Action',
        key: 'action',
        width: 100,
        fixed: 'rigth',
        render: (text, record) => (
          <Space size="middle">
            {currentUser.permissions.permissions.customer.includes(
              'change_undergroup',
            ) && (
                <Link onClick={() => onEdit(record)}>
                  <Tooltip title="Edit">
                    <EditIcon />
                  </Tooltip>
                </Link>
              )}
            {currentUser.permissions.permissions.customer.includes(
              'delete_undergroup',
            ) && (
                <Link>
                  <Tooltip title="Archive">
                    <Popconfirm
                      title="Are you sure you want to archive this record?"
                      onConfirm={() => handleDelete(record.id)} // Trigger delete on confirmation
                      onCancel={() => message.info('Action cancelled')} // Optional cancel action
                      okText="Yes"
                      cancelText="No"
                    >
                      <Archive style={{ cursor: 'pointer' }} />
                    </Popconfirm>
                  </Tooltip>
                </Link>
              )}
          </Space>
        ),
      },
    ];
  
    const handleColumnVisibilityChange = checkedValues => {
      setCheckedList(checkedValues);
    };
  
    const dynamicColumns = columns.filter(column =>
      checkedList.includes(column.dataIndex || column.key),
    );
  
    const columnMenu = (
      <Menu className="packagelistdropdown">
        <Menu.Item key="columnMenu">
          <Checkbox.Group
            value={checkedList}
            onChange={checkedValues => {
              handleColumnVisibilityChange(checkedValues);
            }}
          >
            <Row gutter={16}>
              <Col xs={12} md={12}>
                <Checkbox value="SrNo" disabled>
                  Sr.No.
                </Checkbox>
              </Col>
              <Col xs={12} md={12}>
                <Checkbox value="party_name">Party Name</Checkbox>
              </Col>
              <Col xs={12} md={12}>
                <Checkbox value="vehicle_no">Vehicle No.</Checkbox>
              </Col>
            
              <Col xs={12} md={12}>
                <Checkbox value="tare_wt">Tare WT</Checkbox>
              </Col>
          
              <Col xs={24} md={12}>
                <Checkbox value="created_at">Created At</Checkbox>
              </Col>
              <Col xs={24} md={12}>
                <Checkbox value="created_by_name">Created By</Checkbox>
              </Col>
              <Col xs={24} md={12}>
                <Checkbox value="updated_at">Updated At</Checkbox>
              </Col>
              <Col xs={24} md={12}>
                <Checkbox value="updated_by_name">Updated By</Checkbox>
              </Col>
              <Col xs={12} md={12}>
                <Checkbox value="action" disabled>
                  Action
                </Checkbox>
              </Col>
            </Row>
          </Checkbox.Group>
        </Menu.Item>
      </Menu>
    );
  
    const csvheaders = [
      { label: 'Sr. No', key: 'SrNo' },
      { label: 'Party Name', key: 'party_name' },
      { label: 'Vehicle No.', key: 'vehicle_no' },
      { label: 'Tare WT', key: 'tare_wt' },
      { label: 'created At', key: 'created_at' },
      { label: 'created By', key: 'created_by_name' },
      { label: 'Updated At', key: 'updated_at' },
      { label: 'Updated By', key: 'updated_by_name' },
    ];
  
    const csvFilterheaders = csvheaders.filter(column =>
      checkedList.includes(column.key),
    );
  
    const csvData = data.map((item, index) => ({
      SrNo: index + 1, // Add serial number dynamically
      party_name: item.party_name, // Keep the original group name
      vehicle_no: item.vehicle_no, // Keep the original group name
      tare_wt: item.tare_wt, // Keep the original group name
      created_at: item.created_at
        ? moment(item.created_at).format('DD-MM-YYYY')
        : 'N/A',
      created_by_name: item.created_by_name
        ? `${item.created_by_name}`
        : 'N/A',
      updated_at: item.updated_at
        ? moment(item.updated_at).format('DD-MM-YYYY')
        : 'N/A',
      updated_by_name: item.updated_by_name
        ? `${item.updated_by_name}`
        : 'N/A',
    }));
  
    const handlePdfDownload = async () => {
      const pdf = new jsPDF('p', 'pt', 'a4');
      const pdfColumns = [
        { header: 'Sr No.', dataKey: 'SrNo' },
        { header: 'Party Name', dataKey: 'party_name' },
        { header: 'Vehicle No.', dataKey: 'vehicle_no' },
        { header: 'Tare WT', dataKey: 'tare_wt' },
        
        { header: 'Created At', dataKey: 'created_at' },
        { header: 'Created By', dataKey: 'created_by_name' },
        { header: 'Updated At', dataKey: 'updated_at' },
        { header: 'Updated By', dataKey: 'updated_by_name' },
      ];
  
      const pdffilteredColumns = pdfColumns.filter(column =>
        checkedList.includes(column.dataKey)
      );
  
      const rows = data.map((item, index) => ({
        SrNo: index + 1,
        party_name: item.party_name || 'N/A',
        vehicle_no: item.vehicle_no || 'N/A',
        tare_wt: item.tare_wt || 'N/A',
        created_at: item.created_at
          ? moment(item.created_at).format('DD-MM-YYYY')
          : 'N/A',
        created_by_name: item.created_by_name
          ? `${item.created_by_name}`
          : 'N/A',
        updated_at: item.updated_at
          ? moment(item.updated_at).format('DD-MM-YYYY')
          : 'N/A',
        updated_by_name: item.updated_by_name
          ? `${item.updated_by_name}`
          : 'N/A',
      }));
  
      const pageWidth = pdf.internal.pageSize.width;
      const pageHeight = pdf.internal.pageSize.height;
  
      // ✅ Add Heading
      pdf.setFont('times', 'bold');
      pdf.setFontSize(16);
      const headingText = 'Vehicle List';
      const headingX = pageWidth / 2 - pdf.getTextWidth(headingText) / 2;
      pdf.text(headingText, headingX, 40);
  
      pdf.addImage(logo, 'PNG', pageWidth - 100, 10, 90, 30);
  
      pdf.autoTable({
        columns: pdffilteredColumns,
        body: rows,
        startY: 65,
        theme: 'grid',
        styles: {
          font: 'times',
          halign: 'center',
          overflow: 'linebreak',
          cellPadding: 3.5,
          lineWidth: 0.5,
          lineColor: [0, 0, 0],
          textColor: [0, 0, 0],
        },
        headStyles: {
          textColor: [0, 0, 0],
          fontStyle: 'bold',
          lineWidth: 0.5,
          lineColor: [0, 0, 0],
          fillColor: false,
        },
        rowStyles: {
          lineWidth: 0.5,
          lineColor: [0, 0, 0],
        },
        tableLineColor: [0, 0, 0],
        rowPageBreak: 'avoid',
  
        didDrawPage: function (data) {
          const pageCount = pdf.internal.getNumberOfPages();
          const currentPage = pdf.internal.getCurrentPageInfo().pageNumber;
  
          // ✅ Footer Date & Time (left bottom)
          const dateStr = moment().format('DD-MM-YYYY HH:mm');
          pdf.setFontSize(9);
          pdf.text(dateStr, 40, pageHeight - 20);
  
          // ✅ Footer Page Number (right bottom)
          pdf.text(
            `Page ${currentPage} of ${pageCount}`,
            pageWidth - 100,
            pageHeight - 20
          );
        },
      });
  
      pdf.save(`vehicletype${+new Date()}.pdf`);
  
      dispatch(
        createActivityLog({
          action: 'DOWNLOAD',
          module_name: 'Vehicle',
          ip_address: ipAddress,
          discription: 'Vehicle pdf download successfully!',
        })
      );
    };
  
    const activityLog = async () => {
      dispatch(
        createActivityLog({
          action: 'DOWNLOAD',
          module_name: 'Vehicle',
          ip_address: ipAddress,
          discription: 'Vehicle excel download successfully!',
        }),
      );
    };
    return (
      <div className='mainwrap'>
        <div className="sticyaction">
          <Row
            className="pagenamerow mb-0"
            justify="space-between"
            align="middle"
          >
            <Col>
              <h2 style={{ margin: 0 }}>Vehicle Master (For Tare Weight)</h2>
              <div className="bredcrumbwrp">
              <Link
                  className="back"
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  <Back /> BACK
                </Link>
                <Breadcrumb
                  items={[
                    { title: <Link to="/dashboard">Home</Link> },
                    { title: 'Vehicle Master' },
                  ]}
                />
              </div>
            </Col>
            <Col>
              <Space size="small">
                <Input
                  placeholder="Search"
                  className="searchbox"
                  prefix={<SearchOutlined />}
                  value={search}
                  style={{ width: 200 }}
                  onChange={handleSearch}
                />
                <Button
                  type="primary"
                  disabled={!search && !orderBy}
                  className="iconlink"
                  onClick={resetFilter}
                >
                  <FilterIcon />
                </Button>
                {currentUser.permissions.permissions.customer.includes(
                  'download_under_group_excel_copy',
                ) && (
                    <Tooltip
                      placement="top"
                      title={'Export Excel'}
                      onClick={activityLog}
                    >
                      <Button
                        type="primary"
                        className="iconlink"
                        style={{ width: '10px' }}
                      >
                        <CSVLink
                          filename={'Vehicle.csv'}
                          className="iconlink"
                          style={{ width: '10px' }}
                          data={csvData}
                          headers={csvFilterheaders}
                        >
                          <FileExcelOutlined />
                        </CSVLink>
                      </Button>
                    </Tooltip>
                  )}
                {currentUser.permissions.permissions.customer.includes(
                  'download_under_group_pdf_copy',
                ) && (
                    <Tooltip placement="top" title={'Export PDF'}>
                      <Button
                        type="primary"
                        className="iconlink"
                        onClick={handlePdfDownload}
                      >
                        <FilePdfOutlined />
                      </Button>
                    </Tooltip>
                  )}
                {currentUser.permissions.permissions.customer.includes(
                  'add_undergroup',
                ) && (
                    <Button
                      type="primary"
                      icon={<PlusOutlined />}
                      onClick={showDrawer}
                    >
                      <Tooltip title={'Add Vehicle'}>Add Vehicle</Tooltip>
                    </Button>
                  )}
                {currentUser.permissions.permissions.customer.includes(
                  'delete_undergroup',
                ) && (
                    <Link to="/archive-vehicle-list" className="iconlink">
                      <Tooltip title={'Archive'}>
                        <Archiveicon />
                      </Tooltip>
                    </Link>
                  )}
                <div className="gridiconswrap">
                  <Tooltip placement="topLeft" title="Column Filter Options">
                    <Dropdown
                      overlay={columnMenu}
                      trigger={['click']}
                      placement="bottomRight"
                      visible={dropdownVisible}
                      onVisibleChange={setDropdownVisible}
                    >
                      <Button
                        type="primary"
                        icon={<ColumnList />}
                        onClick={e => e.preventDefault()}
                      />
                    </Dropdown>
                  </Tooltip>
                </div>
              </Space>
            </Col>
          </Row>
        </div>
        <div className='tablewrp'>
          <Table
            rowKey="id"
            columns={dynamicColumns}
            dataSource={dataSource}
            
            pagination={false} 
            loading={loading}
            onChange={handleTableChange}
            scroll={{ x: '600px' }}
          />
        </div>
  
        <Pagination
          current={page}
          pageSize={pagesize}
          total={totalRecord}
          showSizeChanger
          onShowSizeChange={handlePageSizeChange}
          pageSizeOptions={['20', '50', '100']}
          showTotal={total => `Total ${total} items`}
          onChange={handlePageChange}
          locale={{ items_per_page: 'Items / Page' }}
        />
  
        <Drawer
          title={isEditing ? 'Edit Vehicle' : 'Create Vehicle'}
          width={400}
          onClose={closeDrawer}
          visible={isDrawerVisible}
          styles={{
            body: { paddingBottom: 80 },
          }}
        >
          <Form layout="vertical" form={form} onFinish={onFinish}  initialValues={{
                tare_wt: 0,
             
              }}>
            <Form.Item
              name="party_name"
              label="Party Name"
              rules={[{ required: true, message: 'Please enter party name' }]}
              // help={formErrorMessage || undefined}
              // validateStatus={formErrorMessage ? 'error' : undefined}
             
            >
              <Input
                placeholder="Enter Party Name"
                onChange={e => {
                  const input = e.target;
                  const value = input.value;
  
               
  
             
                  form.setFieldsValue({
                    party_name: value,
                  });
             
                }}
              />
            </Form.Item>
            <Form.Item
              name="vehicle_no"
              label="Vehicle No."
              rules={[{ required: true, message: 'Please enter vehicle no.' }]}
              // help={formErrorMessage || undefined}
              // validateStatus={formErrorMessage ? 'error' : undefined}
            >
              <Input
                placeholder="Enter Vehicle No."
                onChange={e => {
                  const input = e.target;
                  const value = input.value;
  
                  // const caretPosition = input.selectionStart;
  
             
                  form.setFieldsValue({
                    vehicle_no: value,
                  });
                  // setTimeout(() => {
                  //   input.setSelectionRange(caretPosition, caretPosition);
                  // }, 0);
                }}
              />
            </Form.Item>
            {/* <Form.Item
                             label="Tare WT"
                             name="tare_wt"
                             rules={[
                               { required: true, message: 'Please enter tare wt' },
                               // {
                               //   pattern: /^\d*\.?\d*$/,
                               //   message: 'Please enter only digits & decimal.',
                               // },
                               createNumberValidationRule({
                                 allowNegative: false,
                                 maxBeforeDecimal: 10, // Set max before decimal
                                 maxAfterDecimal: 3, // Set max after decimal
                                 allowDecimal: true,
                                 allowZero: true,
                               }),
                             ]}
                           >
                             <Input placeholder="Tare WT" maxLength={15} />
                           </Form.Item> */}
                           <Form.Item
  label="Tare WT"
  required
  style={{ marginBottom: 16 }}
>
  <Row gutter={8} align="middle">
    <Col flex="auto">
      <Form.Item
        name="tare_wt"
        noStyle
        rules={[
          { required: true, message: 'Please enter tare wt' },
          createNumberValidationRule({
            allowNegative: false,
            maxBeforeDecimal: 10,
            maxAfterDecimal: 3,
            allowDecimal: true,
            allowZero: true,
          }),
        ]}
      >
        <Input placeholder="Tare WT" maxLength={15} />
      </Form.Item>
    </Col>
    <Col>
      <Button
        type="default"
        icon={<CopyOutlined />} // optional, for clipboard icon
        style={{ whiteSpace: 'nowrap' }}
      >
        Paste Live Weight
      </Button>
    </Col>
  </Row>
</Form.Item>

            <div className="flex justify-end">
              <Form.Item>
                <Button type="primary" htmlType="submit" icon={<PlusOutlined />}>
                  {isEditing ? 'Update Vehicle' : 'Create Vehicle'}
                </Button>
              </Form.Item>
            </div>
            {formErrorMessage && (
            <div
              style={{
                color: "red",
                marginTop: 10,
                fontSize: 14,
                textAlign: "center",
              }}
              dangerouslySetInnerHTML={{ __html: formErrorMessage }}
            />
          )}
          </Form>
        </Drawer>
      </div>
    );
  }
  
  export default VehicleList;
